module.exports = __webpack_public_path__ + "img/selfDevelopedRapidDebuggingAndDeployment.1a7dba9f.svg";